import React, { type JSX } from "react";
import type { AdminAiRuntimeSummaryItemViewModel } from "../locale/admin-ai-runtime-summary";
import { AdminAggregateSummaryStrip } from "./admin-aggregate-summary-strip";

export type AdminAiRuntimeSummaryStripProps = {
  title: string;
  items: AdminAiRuntimeSummaryItemViewModel[];
  sourceGapLabel?: string;
  ariaLabel: string;
};

export function AdminAiRuntimeSummaryStrip(
  props: AdminAiRuntimeSummaryStripProps,
): JSX.Element {
  return <AdminAggregateSummaryStrip {...props} />;
}
